<template>
    <div class="container-fluid">
        <!-- Button -->
        <a href="#" class="mb-3 btn" :class="{'btn-success': !addNews, 'btn-secondary': addNews}" @click.prevent="addNews = !addNews">{{!addNews ? 'Añadir noticia' : 'Cancelar'}}<i class="ml-1 fa" :class="{'fa-save': !addNews, 'fa-window-close': addNews}"></i></a>

        <!-- List -->
        <div class="card mb-5" v-show="!addNews">
            <div class="card-body table-responsive">
                <h5 class="card-title">Noticias</h5>
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Contenido</th>
                            <th>Género</th>
                            <th>Rango edad</th>
                            <th>Rol</th>
                            <th>Todos</th>
                            <th>Fecha de creación</th>
                            <th>Eliminar noticia</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(nu, i) in newss" :key="nu.id">
                            <td>{{i+1}}</td>
                            <td style="max-width: 250px">
                                <audio controls v-if="nu.type == 'audio'" style="width: 100%; height: 30px">
                                    <source :src="nu.audio_file" type="audio/mp3">
                                </audio>

                                <div v-else-if="nu.type == 'video'" class="embed-responsive embed-responsive-16by9">
                                    <iframe class="embed-responsive-item" :src="getEmbed(nu.video)" allowfullscreen></iframe>
                                </div>

                                <div v-else-if="nu.type == 'texto'">
                                    <p><b>{{nu.title}}</b></p>
                                    <p style="float: left; padding: 0px 10px 10px 0px; margin: 0" ><img :src="nu.image_file" width="120px" alt=""></p>
                                    <p style="white-space: pre-wrap;">{{nu.description}}</p>
                                </div>
                            </td>
                            <td><span :class="{'all_users': nu.all_users == 1}">{{nu.all_users == 1 ? 'No aplica' : nu.gender_name}}</span></td>
                            <td><span :class="{'all_users': nu.all_users == 1}">{{nu.all_users == 1 ? 'No aplica' : `De ${nu.min_age} a ${nu.max_age} años`}}</span></td>
                            <td><span :class="{'all_users': nu.all_users == 1}">{{nu.all_users == 1 ? 'No aplica' : nu.role}}</span></td>
                            <td><i class="fa" :class="{'fa-check': nu.all_users, 'fa-times': !nu.all_users}"></i></td>
                            <td><span class="date">{{nu.created_at}}</span></td>
                            <td><a href="#" class="btn btn-danger btn-sm" @click.prevent="deleteNews(nu.id)"><i class="fa fa-trash"></i></a></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Form -->
        <div class="card card-body" v-show="addNews">
            <h5 class="card-title mb-3">Publicar noticia en...</h5>
            <div class="row mb-4">
                <div class="col-sm-4">
                    <a href="#" class="btn btn-primary btn-block" @click.prevent="type = 'texto'">Texto <i class="ml-1 fa fa-file"></i></a>
                </div>
                <div class="col-sm-4">
                    <a href="#" class="btn btn-warning btn-block" @click.prevent="type = 'audio'">Audio <i class="ml-1 fa fa-file-audio"></i></a>
                </div>
                <div class="col-sm-4">
                    <a href="#" class="btn btn-danger btn-block" @click.prevent="type = 'video'">Video <i class="ml-1 fa fa-file-video"></i></a>
                </div>
            </div>
            <form action="" @submit.prevent="store">
                <div class="row">
                    <div class="col-sm-4 col-12">
                        <div class="card">
                            <div class="card-body">
                                <h5 class="card-title">Contenido: </h5>
            
                                <div class="form-group" v-if="type === 'texto'">
                                    <label for="">Título:</label>
                                    <input required type="text" class="form-control mb-4" v-model="news.title">
            
                                    <label for="">Añadir texto noticia: </label>
                                    <textarea required style="resize: none" name="description" id="" cols="30" rows="10" class="form-control" v-model="news.description"></textarea>
                                    <a href="#" @click="$refs.image.click()" class="btn btn-block btn-primary mt-4">
                                        <span v-if="news.image.name">Cambiar: {{news.image.name}}</span> 
                                        <span v-else>Subir imagen</span> 
                                        <i class="ml-1 fa fa-image"></i>
                                    </a>
                                    <input required style="display: none" @change="selectImage" accept="image/x-png,image/gif,image/jpeg" type="file" ref="image">
                                </div>
            
                                <a href="#" class="btn" :class="{'btn-danger recording': recording, 'btn-primary': !recording}" v-else-if="type === 'audio'" @click.prevent="record">
                                    {{recording ? 'Detener grabación' : 'Iniciar grabación'}} <i class="fa fa-microphone ml-1"></i>
                                </a>
                                
            
                                <div class="form-group" v-if="type === 'video'">
                                    <label for="">Añadir link de YouTube: </label>
                                    <input required type="text" class="form-control" v-model="news.video">
                                    <small>
                                        El formato del link de Youtube debe ser tomado desde la caja superior del navegador. <br>
                                        Debe ser de tipo <i>/watch?v=</i><br>
                                        Por ejemplo: <b>https://www.youtube.com<span style="color: red">/watch?v=</span>lNbYlHpw0-A</b>
                                    </small>
                                </div>
                            </div>
        
                        </div>
                    </div>
        
                    <div class="col-sm-8">
                        <div class="card">
                            <div class="card-body">
                                <h5 class="card-title">Permisos</h5>
                                <h6 class="card-subtitle mb-4 text-muted">¿Quién puede ver esta noticia?</h6>
                                <div class="row">
                                    <div class="col-sm-3 col-12">
                                        <p><b>Género:</b> </p>
                                        <div class="form-check">
                                            <input v-model="news.gender" class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" :value="1" checked>
                                            <label class="form-check-label" for="exampleRadios1">
                                                Masculino
                                            </label>
                                        </div>
                                        <div class="form-check">
                                            <input v-model="news.gender" class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios2" :value="2">
                                            <label class="form-check-label" for="exampleRadios2">
                                                Femenino
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-sm-4 col-12">
                                        <p><b>Edad:</b> </p>
                                        <div class="form-group">
                                            <label for="">Desde: </label>
                                            <input v-model="news.min_age" type="number" min="0" class="form-control">
                                        </div>
                                        <div class="form-group">
                                            <label for="">Hasta: </label>
                                            <input v-model="news.max_age" type="number" min="1" class="form-control">
                                        </div>
                                    </div>
                                    <div class="col-sm-5 col-12">
                                        <div class="form-group">
                                            <label for=""><b>Rol: </b></label>
                                            <select :required="!news.all_users" name="role" id="" class="form-control" v-model="news.role_id">
                                                <option value="">Seleccionar rol</option>
                                                <option v-for="role in roles" :key="role.id" :value="role.id">{{role.name}}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-check">
                                    <input v-model="news.all_users" type="checkbox" class="form-check-input" id="all_users">
                                    <label style="cursor: pointer" class="form-check-label" for="all_users">Todos los usuarios </label>
                                </div>
                            </div>
                        </div>
                        <button type="submit" class="btn btn-success mt-4">Enviar noticia <i class="fa fa-save ml-1"></i></button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
function emptyNews(){
    return {
        title: "",
        description: "",
        image: {},
        audio: null,
        video: "",
        gender: 1,
        min_age: 0,
        max_age: 1,
        role_id: "",
        all_users: false,
    }
    
}

import AudioRecorder from 'audio-recorder-polyfill';
window.MediaRecorder = AudioRecorder;

export default {
    name: "News",
    mounted(){
        this.fetchRoles();
        this.fetchNews();
    },
    data: () => ({
        addNews: false,
        type: "texto",
        roles: [],
        news: emptyNews(),
        newss: [],
        recording: false,
        recorder: null,
    }),
    methods: {
        deleteNews(id){
            const url = `${this.$api}/admin/news/${id}`;
            this.$http.delete(url).then(response => {
                const index = this.newss.findIndex(news => news.id == response.body.data.id);
                this.newss.splice(index, 1);
            })
        },

        record(){
            let device = navigator.mediaDevices.getUserMedia({audio: true});
            var items = [];

            if(this.recording === true){
                this.recorder.stop();
                this.recording = false;
                return;
            }
            
            device.then(stream => {
                this.recorder = new MediaRecorder(stream);

                this.recorder.addEventListener('dataavailable', e => {
                    items.push(e.data);
                    if (this.recorder.state == 'inactive'){
                        this.news.audio = new Blob(items, {type: 'audio/mp3'});
                        console.log(this.news.audio);
                    }
                })
                this.recording = true;
                this.recorder.start();
            })
            
        },
        selectImage(e){
            let file = e.target.files[0];
            this.news.image = file ? file : {};
        },
        fetchRoles(){
            const url = `${this.$api}/admin/types?type=role`;
            this.$http.get(url).then(response => {
                this.roles = response.body.data;
            })
        },
        fetchNews(){
            const url = `${this.$api}/admin/news`;
            this.$http.get(url).then(response => {
                this.newss = response.body.data;
            })
        },
        getEmbed(link){
            let clean = link.split('&')[0];
            let newLink = `${clean.replace('watch?v=', 'embed/')}?rel=0`;
            return newLink;
        },
        validateYoutubeLink(){
            let valid = /^(?:https?:\/\/)?(?:www\.)(?:youtube\.com\/(?:watch\?v=))((\w|-){11})?(&.*)?$/;
            return valid.test(this.news.video);
        },
        store(){
            if(this.type === 'audio' && !this.news.audio == null) {
                alert("Debe grabar un audio para enviar esta noticia");
                return;
            }

            if(this.type === 'video'){
                const valid = this.validateYoutubeLink();
                if(!valid) {
                    this.$dialogs.alert('Youtube de link inválido para la operación', {title: 'YouTube', size: 'sm'}).then(() => {
                        this.$dialogs.alert('Debes copiar el link de Youtube desde la URL (Caja superior).', {title: 'YouTube', size: 'sm'})
                    })
                    return;
                }

            }

            const formData = new FormData();
            formData.append('gender', this.news.gender);
            formData.append('min_age', this.news.min_age);
            formData.append('max_age', this.news.max_age);
            formData.append('all_users', this.news.all_users == true ? 1 : 0);
            formData.append('role_id', this.news.role_id);
            formData.append('type', this.type);

            if(this.type === 'texto'){
                formData.append('title', this.news.title);
                formData.append('image', this.news.image);
                formData.append('description', this.news.description);
            } else if(this.type === 'audio' && this.news.audio){
                formData.append('audio', this.news.audio);
            } else if(this.type === 'video'){
                formData.append('video', this.news.video);
            }

            const url = `${this.$api}/admin/news`
            this.$http.post(url, formData).then(response => {
                this.newss.unshift(response.body.data);
                this.news = emptyNews();
                this.addNews = false;
            })
        }
    }
}
</script>

<style lang="scss" scoped>
    .date {
        padding: 4px 8px;
        border: 1px solid gray;
    }

    .all_users {
        padding: 4px 8px;
        color: white;
        background-image: linear-gradient(70deg, red, rgb(255, 0, 98));
    }

    .recording {
        background-color: red;
        animation: recording infinite ease 2s;
    }

    @keyframes recording {
        0% {
            box-shadow: 0px 0px 0px red;
            transform: scale(1)
        }

        50% {
            box-shadow: 0px 0px 30px red;
            transform: scale(1.05)
        }

        100% {
            box-shadow: 0px 0px 0px red;
            transform: scale(1)
        }
    }
</style>